import React from 'react';

// Import required components
import { Heading, Activity } from '../../../components';
import { activities } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';



const Activities = () => { 

  return (
    <section className='activities'>

      {/* Section heading */}
      <Heading title={'Our activities'} subTitle={'Explore Our Premier activities'} />

      <Swiper

        modules={[Autoplay]} // Enable Autoplay feature
        spaceBetween={10} // Space between slides
        loop={true} // Enables Infinite Loop
        autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-scroll every 4 seconds

        // Responsive Breakpoints for Different Screen Sizes
        breakpoints={{
          450: { slidesPerView: 1 }, // 1 slide for small screens
          768: { slidesPerView: 2 }, // 2 slides for tablets
          991: { slidesPerView: 3 }, // 3 slides for larger screens
        }}

      >

        {/* Map over the activities array to render each activity */}
        {activities.map((activity) => { 
          return (
            <SwiperSlide key={activity.id}>

              {/* Render individual Activity component */}
              <Activity activity={activity} />

            </SwiperSlide>
          );
        })}

      </Swiper>

    </section>
  )
}

export default Activities;